import React from 'react';
import { Activity, Zap } from 'lucide-react';
import { DashboardWidget } from './DashboardWidget';
import { useOptimizedDashboardData } from '@/hooks/useOptimizedDashboardData';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const OptimizedAIRunCoachTeaser: React.FC = React.memo(() => {
  const { runningCoachData, runningCoachLoading } = useOptimizedDashboardData();

  if (runningCoachLoading) {
    return (
      <Card className="h-full animate-pulse">
        <CardHeader>
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-10 w-full" />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!runningCoachData) return null;

  const badges = [
    'Performance',
    ...(runningCoachData.hasExternalData ? ['Strava'] : [])
  ];

  return (
    <DashboardWidget
      title="AI Running Coach"
      description="Personalized running insights and training guidance"
      icon={Activity}
      primaryColor="primary"
      ctaText="Get Running Coaching"
      ctaLink="/ai-coach"
      data={runningCoachData}
      badges={badges}
    />
  );
});